import Service from "./Service"

class TaskChatMessageService extends Service {

    findAllByTask = (taskId, queryParams) => this.getWithParams(`/tasks/${taskId}/chat-messages`, queryParams)

    create = (taskId, requestBody) => this.post(`/tasks/${taskId}/chat-messages`, requestBody)

    update = (id, requestBody) => this.patch(`/tasks/chat-messages/${id}`, requestBody)

    delete = (id) => this.del(`/tasks/chat-messages/${id}`)

    react = (id, requestBody) => this.post(`/tasks/chat-messages/${id}/reactions`, requestBody)
}

const taskChatMessageService = new TaskChatMessageService()
export default taskChatMessageService